import { FormControl, UntypedFormGroup } from '@angular/forms';
import { WorldpayFormField } from '../../models/worldpay/worldpay-form-field.enum';
import { WorldpayForm } from '../../models/worldpay/worldpay-form.interface';

export const mockWorldpayForm: WorldpayForm = {
  [WorldpayFormField.BillingAddress]: new UntypedFormGroup({
    id: new FormControl(),
    addressLine1: new FormControl(),
    addressLine2: new FormControl(),
    addressLine3: new FormControl(),
    addressLine4: new FormControl(),
    postalCode: new FormControl(),
    countryCode: new FormControl(),
    countryIso2: new FormControl(),
    countryIso3: new FormControl(),
    countryIsoNumber: new FormControl(),
    countryName: new FormControl(),
    type: new FormControl(),
    sameAsAddress: new FormControl(),
  }),
  [WorldpayFormField.Address]: new UntypedFormGroup({
    id: new FormControl(),
    addressLine1: new FormControl(),
    addressLine2: new FormControl(),
    addressLine3: new FormControl(),
    addressLine4: new FormControl(),
    postalCode: new FormControl(),
    countryCode: new FormControl(),
    countryIso2: new FormControl(),
    countryIso3: new FormControl(),
    countryIsoNumber: new FormControl(),
    countryName: new FormControl(),
    type: new FormControl(),
  }),
  [WorldpayFormField.PaperlessPreference]: new FormControl(null),
  [WorldpayFormField.TermsAndConditions]: new FormControl(null),
};
